import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-50">
      <div className="w-full max-w-[1240px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-background-50 text-primary-600">
                <i className="ri-smartphone-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-bold text-base">手机中文大全10</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-100/80">
              最近最新手机中文大全10 专注中文手机软件合集与最新版本资讯，提供清晰完整的软件分类、版本更新与使用介绍，帮助用户快速找到所需应用。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 flex items-center gap-2">
              <a href="#footer-cat" className="cursor-pointer">软件分类</a>
            </h4>
            <ul id="footer-cat" className="space-y-2.5 text-sm text-background-100/80">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.id}`} className="hover:text-background-50 transition-colors cursor-pointer">
                    {cat.name}软件
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">快捷入口</h4>
            <ul className="space-y-2.5 text-sm text-background-100/80">
              <li>
                <Link to="/" className="hover:text-background-50 transition-colors cursor-pointer">网站首页</Link>
              </li>
              <li>
                <Link to="/search?q=" className="hover:text-background-50 transition-colors cursor-pointer">软件搜索</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-background-50 transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <Link to="/about#feedback" className="hover:text-background-50 transition-colors cursor-pointer">意见反馈</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-100/80">
              <li className="flex items-center gap-2">
                <span className="flex items-center justify-center w-5 h-5"><i className="ri-mail-line" aria-hidden="true"></i></span>
                support@shoujidaquan10.example.com
              </li>
              <li className="flex items-center gap-2">
                <span className="flex items-center justify-center w-5 h-5"><i className="ri-time-line" aria-hidden="true"></i></span>
                服务时间：周一至周五 9:00-18:00
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-1 text-2xl text-background-100/70">
              <span className="flex items-center justify-center w-7 h-7"><i className="ri-wechat-line" aria-hidden="true"></i></span>
              <span className="flex items-center justify-center w-7 h-7"><i className="ri-weibo-line" aria-hidden="true"></i></span>
              <span className="flex items-center justify-center w-7 h-7"><i className="ri-mail-send-line" aria-hidden="true"></i></span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15">
          <p className="text-xs text-background-100/60 leading-relaxed">
            友情提示：本站为手机中文软件信息与版本资讯的演示站点，页面中的下载按钮仅作跳转演示，不提供真实下载与安装包，也不统计下载行为。
            请通过应用商店或软件官方网站获取正版软件。本站内容为示例数据，仅供学习与体验。
          </p>
          <div className="mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-background-100/70">
            <p>© 2026 最近最新手机中文大全10. 保留所有权利.</p>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
              <a href="#footer-service" className="hover:text-background-50 transition-colors cursor-pointer">友情链接：中文软件导航</a>
              <a href="#footer-service" className="hover:text-background-50 transition-colors cursor-pointer">开发者收录</a>
              <a href="#footer-service" className="hover:text-background-50 transition-colors cursor-pointer">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}